import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

class FailedFeedback extends Component {
  render() {
    const tooltip = <Tooltip>{this.props.error}</Tooltip>;
    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <span
          className={'form-control-feedback glyphicon glyphicon-remove'}
          style={{ 'pointer-events': 'auto', cursor: 'pointer' }}
        />
      </OverlayTrigger>
    );
  }
}

FailedFeedback.propTypes = {
  error: PropTypes.bool.isRequired,
};

export default FailedFeedback;
